/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:41:07
 */
const s = {
    ballDistance: 19,
    diameter: 9.61,
    numRows: 14,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [325.53843489862885, 325.0502786213443, 328.1095988107053, 356.71071968088376, 325.5609266175977],
        1: [327.0396876295794, 325.5632747986541, 354.10460361526674, 325.6274214604864, 327.39323042445625, 325.70245360066065],
        2: [327.8058837910042, 327.7393361369064, 325.4840273291911, 327.91602049558185, 327.63737717746454, 328.5319169850193, 326.055307384771, 327.80391636401663],
        3: [353.775265319383, 327.55092501147533, 356.0177322120363, 328.54098722040226, 325.56122624798013, 328.1243647884604, 327.05941266628815, 328.0549296690157],
        4: [325.6138042089518, 328.1377898908639, 327.5327749698002, 354.12504236628, 354.1724377579664, 326.0844044193328, 327.9161881035139, 353.68581422784547],
        5: [356.25148366772066, 356.4073652495667, 327.96001564097634, 327.58907575655417, 354.2828910926403, 325.5519303321134, 327.68251585931193, 327.40610954177913],
        6: [356.36667573764, 356.3746545911801, 327.12159730494113, 325.5210948836142, 328.37772887194836, 325.76388344761943, 325.49250277166544, 328.00193397002096],
        7: [327.8544527834603, 353.7090791699984, 328.31387837400894, 354.48564318621084, 328.0428658395899, 354.91789578277434, 327.4568025607898, 325.38875325864666],
        8: [356.3851712373367, 327.71960247640703, 356.39590921304386, 327.91830954901076, 356.07163665545045, 356.58174643149823, 353.9847703529169, 356.73104157526257],
        9: [357.2788308251745, 354.51866368089094, 353.67761052338057, 356.4627517785657, 356.64876739608593, 354.0245574679176, 356.42737162212956, 325.44068706843393],
        10: [327.89290870821776, 354.39144972175353, 354.25375541508475, 354.45800563313287, 325.8609959969132, 326.0397520669281, 356.2247278844513, 353.72421015351034],
        11: [354.5482654002409, 326.088208000598, 356.5330146807214, 325.606763738179, 327.84207763407903, 325.4459067448005, 327.8879416830775, 325.44695178377236],
        12: [356.2249701467508, 356.29447608113185, 354.4418942886222, 327.3615253260648, 325.4781354438459, 354.1945179533255, 327.89530290955634, 325.8352164805561],
        13: [357.11982050707917, 356.4013882900257, 354.5237607626402, 354.3194699268047, 328.63712922759356, 354.36416243139024, 353.46411266213016, 326.8883237527306],
        14: [356.505897154775, 354.4940162112512, 328.4558769522524, 354.6107941008217],
        15: []
    }
};
export {s as default};
